<div class="container-fluid">
  <div class="row pt-4">
    <div class="col-md-12 text-center mb-2">
      <small class="footer-text"> www.ifxnetworks.com 2021  © todos los derechos reservados. </small>
    </div>
  </div>
</div>